module.exports = __webpack_public_path__ + "static/media/new-step-indicator-1of2.e24ea2d7.svg";